import { render } from "./CustomLabel.vue?vue&type=template&id=5e6f9bd1"
import script from "./CustomLabel.vue?vue&type=script&lang=js"
export * from "./CustomLabel.vue?vue&type=script&lang=js"

import "./CustomLabel.vue?vue&type=style&index=0&id=5e6f9bd1&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__